<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col md="12">
          <h5 class="section-label mb-3">
            Bulk SMS
          </h5>
        </b-col>
        <b-col
          md="12"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
          <validation-observer ref="bulkSMSRef">
            <b-form>
              <b-row class="match-height">

                <b-col md="4">
                  <SelectField
                    id="products"
                    v-model="bulkSMS.productCodes"
                    :reduce="option => option.value"
                    label="Products"
                    placeholder="Select"
                    :options="productOptions"
                    item="label"
                    multiple
                  />
                </b-col>
                <b-col md="4">
                  <TextAreaField
                    id="phone-number"
                    v-model="bulkSMS.phoneNumbers"
                    placeholder="Enter Phone number separated with commas"
                    rows="1"
                    label="Enter Phone number separated with comma (,)"
                    :is-allow-numbers-with-comma="false"
                  />
                </b-col>
                <b-col md="4">
                  <TextAreaField
                    id="account-number"
                    v-model="bulkSMS.accountNumbers"
                    placeholder="Enter Account number separated with commas"
                    rows="1"
                    label="Enter Account number separated with comma (,)"
                    :is-allow-account-numbers-with-comma="false"
                  />
                </b-col>
              </b-row>
              <b-row class="match-height">
                <b-col
                  md="12"
                  class="mb-0 mt-0"
                >
                  <SwitchButton
                    v-model="bulkSMS.chargeAccount"
                    label="Charge Account?"
                    name="charge-account"
                    :change="setAccountCharge(bulkSMS.chargeAccount)"
                  />
                </b-col>
              </b-row>
              <b-row class="match-height">
                <b-col
                  v-if="isAccountCharge"
                  md="4"
                  class="mb-0 mt-0"
                >
                  <InputField
                    id="sms-charge-per-notification"
                    v-model="bulkSMS.smsChargePerNotification"
                    label="SMS Charge Per Notification"
                    placeholder="SMS Charge Per Notification"
                    type="number"
                    rules="required|limited2Decimal"
                    error-name="SMS Charge Per Notification"
                  />
                </b-col>
                <b-col
                  v-if="isAccountCharge"
                  md="4"
                  class="mb-0 mt-0"
                >
                  <InputField
                    id="minimum-balance"
                    v-model="bulkSMS.minimumBalance"
                    label="Minimum Balance"
                    placeholder="Minimum Balance"
                    type="number"
                    error-name="Minimum Balance"
                    rules="required|limited2Decimal"
                  />
                </b-col>
                <b-col
                  md="4"
                  class="mb-0 mt-2"
                >
                  <SwitchButton
                    v-model="bulkSMS.sendToOnlyActiveAccount"
                    label="Send To Only Active Account?"
                    name="send-to-only-active-account"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <TextAreaField
                    id="account-number"
                    v-model="bulkSMS.message"
                    placeholder="Enter message"
                    rows="3"
                    maxlength="1000"
                    label="Message"
                    error-name="Message"
                    rules="required"
                  />
                </b-col>
                <p class="message-counter">
                  {{ bulkSMS.message.length }} / 1000
                </p>
              </b-row>
              <b-row class="mb-3">
                <b-col>
                  <h4>
                    Keyword Substitutes
                  </h4>
                  [LastName] - Last Name of the customer <br>
                  [FirstName] - First Name of the customer
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <Button
                    v-if="getUserPermission('BULK_SMS')"
                    label="Send SMS"
                    size="md"
                    class="mt-0"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    @click="handleSubmit"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </div>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BForm, VBTooltip,
} from 'bootstrap-vue'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import SelectField from '../../../forms/SelectField.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import SwitchButton from '../../../components/switch/Switch.vue'
import InputField from '../../../forms/InputField.vue'
import Button from '../../../components/button/Button.vue'
import { operationPermissions } from '../../../../helpers/permissions'
import { toKobo } from '../../../../helpers/formatAmount'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BRow,
    BCol,
    Button,
    BForm,
    ValidationObserver,
    SelectField,
    TextAreaField,
    InputField,
    SwitchButton,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      showSpinner: false,
      isLoading: false,
      isDisabled: false,
      isAccountCharge: true,
      required,
      positive,
      bulkSMS: {
        phoneNumbers: '',
        accountNumbers: '',
        productCodes: [],
        chargeAccount: true,
        sendToOnlyActiveAccount: false,
        smsChargePerNotification: 0,
        minimumBalance: 0,
        message: '',
      },
      productOptions: [],
    }
  },
  async mounted() {
    this.fetchProduct()
  },
  methods: {
    ...mapActions({
      getProduct: 'account/getProducts',
      postBulkSMS: 'operations/postBulkSMSActions',
    }),

    async fetchProduct() {
      try {
        const response = await this.getProduct({
          search: { type: 'Savings' },
          page: 0,
          limit: 0,
          permission: operationPermissions.BULK_SMS,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.productOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.code }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    setAccountCharge(selectedValue) {
      this.isAccountCharge = selectedValue
        ? selectedValue === true
        : false
      if (this.isAccountCharge === false) {
        this.bulkSMS.chargeAccount = false
      }
    },
    handleSubmit() {
      this.$refs.bulkSMSRef.validate().then(success => {
        if (success) {
          this.confirm(this.performBulkSMS, { text: 'You are about to send a bulk sms, please be aware that this action cannot be reversed! Are you sure?' })
        }
      })
    },
    async performBulkSMS() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          ...this.bulkSMS,
          productCodes: this.bulkSMS.productCodes.toString(),
          smsChargePerNotification: this.bulkSMS.smsChargePerNotification ? toKobo(this.bulkSMS.smsChargePerNotification) : 0,
          minimumBalance: this.bulkSMS.minimumBalance ? toKobo(this.bulkSMS.minimumBalance) : 0,
        }
        const response = await this.postBulkSMS({ formData, permission: operationPermissions.BULK_SMS })
        const { status } = response
        if (status === 200) {
          this.alertSuccess({ text: 'Your Bulk SMS request was successful' })
          this.resetInputField()
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.bulkSMS = {
        phoneNumbers: '',
        accountNumbers: '',
        productCodes: [],
        chargeAccount: true,
        sendToOnlyActiveAccount: false,
        smsChargePerNotification: 0,
        minimumBalance: 0,
        message: '',
      }
      this.isLoading = false
      this.isDisabled = false
    },
  },
}
</script>

<style scoped>
.message-counter {
  margin-left: 15px;
  margin-top: -10px;
  text-align: right;
}
.tooltip::v-deep .tooltip-inner {
  max-width: 22em;
}
/* .toolkit-format {
  margin-left: -45px;
} */
</style>
